import { render, staticRenderFns } from "./Tema7.vue?vue&type=template&id=55f63995&scoped=true&lang=pug&"
import script from "./Tema7.vue?vue&type=script&lang=js&"
export * from "./Tema7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f63995",
  null
  
)

export default component.exports